<template>
  <div class="qualifio-popup-container">
    <div v-show="showPopup">
      <div id="overlay"></div>
      <div class="qualifio-lead-popup">
        <span class="qualifio-lead-popup-popupClose" @click="closepopup">X</span>
        <slot></slot>
      </div>
    </div>
    <div v-show="showbtn" class="button-container">
      <div class="button-close" @click="buttonclose">✕</div>
      <button class="qualifio-lead-popup-button" @click="showpopup">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'qualifio-popup',
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    hideDurationInDays: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showPopup: false,
      showbtn: true,
    };
  },
  mounted() {
    const modal = document.querySelector('.qualifio-popup-container div:first-child');
    const buttonClose = document.querySelector('.qualifio-lead-popup-popupClose');
    const popupClosedTimestamp = localStorage.getItem('qualifioPopupClosedTime');
    const now = new Date().getTime();
    const hideDuration = this.hideDurationInDays * 24 * 60 * 60 * 1000;

    if (!popupClosedTimestamp || now - popupClosedTimestamp > hideDuration) {
      if (modal) {
        modal.style.display = 'block';
      }
    }

    if (buttonClose) {
      buttonClose.addEventListener('click', () => {
        if (modal) {
          modal.style.display = 'none';
          localStorage.setItem('qualifioPopupClosedTime', new Date().getTime());
        }
      });
    }
  },
  methods: {
    showpopup() {
      this.showPopup = true;
    },
    closepopup() {
      this.showPopup = false;
    },
    buttonclose() {
      this.showbtn = false;
    },
  },
};
</script>
<style lang="scss" src="./qualifio-popup.scss"></style>
